<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {
    this.$auth.logout({ redirect: { name: 'login' } })
  },

  render: () => null,

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
